import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

/**
 * Converte dados do React/Formik para armazenamento no Firestore.
 */
export const eventToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : (tenantData?.idTenant || tenantData?.id);
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const cleanName = data.name?.trim() || "Novo Evento";

    const payload = {
        idTenant,
        name: cleanName,
        searchName: SearchHelper.normalize(cleanName),
        
        startDate: data.startDate,
        endDate: data.endDate,
        
        type: data.type,
        testType: data.type === "test" ? data.testType : null,
        fixedTime: data.type === "test" && data.testType === "fixed_time" ? Number(data.fixedTime) : null,
        fixedDistance: data.type === "test" && data.testType === "fixed_distance" ? Number(data.fixedDistance) : null,
        badgeImageUrl: data.type === "extra" ? data.badgeImageUrl : null,
        rewardXp: data.type === "extra" ? Number(data.rewardXp) : null,
        description: data.description,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove campos indefinidos
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o formato consumível no React.
 */
export const eventFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
